module.exports = (x, y) => `translate(${x}, ${y})`;
